import { ROUTE_CONSTANT } from "../routing/route-constants";
import { useParams } from "react-router-dom";
import { APP_NAVIGATION } from "./constants";
import { availableLanguages } from "../i18nextInit";

export const PathHelper = (sectionName, localeParam) => {
  let locale = localeParam;

  if (locale === undefined) {
    locale =
      localStorage.getItem("i18nextLng") === "en"
        ? ""
        : localStorage.getItem("i18nextLng");
  }
  let pathValue = {
    back: ROUTE_CONSTANT.HOME,
    next: ROUTE_CONSTANT.HOME,
    cstm: ROUTE_CONSTANT.HOME,
  };
  const setLocaleURL = (url) => {
    let verifiedLocale = "";
    if (!!locale && availableLanguages.includes(locale)) {
      verifiedLocale = locale !== "en" ? locale : "";
    }

    return url.replace(":locale/", verifiedLocale ? `${verifiedLocale}/` : "");
  };

  switch (sectionName) {
    case APP_NAVIGATION.SINI:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.LOGIN_LOCALE)
        : ROUTE_CONSTANT.LOGIN_LOCALE;
      break;
    case APP_NAVIGATION.SINU:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.SIGNUP_LOCALE)
        : ROUTE_CONSTANT.SIGNUP;
      break;
    case APP_NAVIGATION.FORGOT_PASSWORD:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.FORGOT_PASSWORD_LOCALE)
        : ROUTE_CONSTANT.FORGOT_PASSWORD;
      break;
    case APP_NAVIGATION.RESET_PASSWORD:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.RESET_PASSWORD_LOCALE)
        : ROUTE_CONSTANT.RESET_PASSWORD;
      break;
    case APP_NAVIGATION.CONFIRMATION:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CONFIRMATION_LOCALE)
        : ROUTE_CONSTANT.CONFIRMATION;
      break;
    case APP_NAVIGATION.PERSONALITY_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.PERSONALITY_REPORT_LOCALE)
        : ROUTE_CONSTANT.PERSONALITY_REPORT;
      break;
    case APP_NAVIGATION.CAREER_PRE_CONTENT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CAREER_PRE_CONTENT_LOCALE)
        : ROUTE_CONSTANT.CAREER_PRE_CONTENT;
      break;
    case APP_NAVIGATION.CAREER_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CAREER_REPORT_LOCALE)
        : ROUTE_CONSTANT.CAREER_REPORT;
      break;
    case APP_NAVIGATION.ADHD_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.ADHD_REPORT_LOCALE)
        : ROUTE_CONSTANT.ADHD_REPORT;
      break;
    case APP_NAVIGATION.BIG_FIVE_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.BIG_FIVE_REPORT_LOCALE)
        : ROUTE_CONSTANT.BIG_FIVE_REPORT;
      break;
    case APP_NAVIGATION.BIG_FIVE_FACETS_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.BIG_FIVE_FACETS_REPORT_LOCALE)
        : ROUTE_CONSTANT.BIG_FIVE_FACETS_REPORT;
      break;
    case APP_NAVIGATION.ENNEAGRAM_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.ENNEAGRAM_REPORT_LOCALE)
        : ROUTE_CONSTANT.ENNEAGRAM_REPORT;
      break;
    case APP_NAVIGATION.LIKEABILITY_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.LIKEABILITY_REPORT_LOCALE)
        : ROUTE_CONSTANT.LIKEABILITY_REPORT;
      break;
    case APP_NAVIGATION.PERSONALITY_DISORDER_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.PERSONALITY_DISORDER_REPORT_LOCALE)
        : ROUTE_CONSTANT.PERSONALITY_DISORDER_REPORT;
      break;
    case APP_NAVIGATION.DISC_PERSONALITY_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DISC_PERSONALITY_REPORT_LOCALE)
        : ROUTE_CONSTANT.DISC_PERSONALITY_REPORT;
      break;
    case APP_NAVIGATION.CAREER_PREFERENCE_PRE_CONTENT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CAREER_PREFERENCE_PRE_CONTENT_LOCALE)
        : ROUTE_CONSTANT.CAREER_PREFERENCE_PRE_CONTENT;
      break;
    case APP_NAVIGATION.CAREER_PREFERENCE_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT_LOCALE)
        : ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT;
      break;
    case APP_NAVIGATION.EMOTIONAL_INTELLIGENCE_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.EMOTIONAL_INTELLIGENCE_REPORT_LOCALE)
        : ROUTE_CONSTANT.EMOTIONAL_INTELLIGENCE_REPORT;
      break;
    case APP_NAVIGATION.DIFFICULT_PERSON_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DIFFICULT_PERSON_REPORT_LOCALE)
        : ROUTE_CONSTANT.DIFFICULT_PERSON_REPORT;
      break;
    case APP_NAVIGATION.AUTISM_SPECTRUM_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.AUTISM_SPECTRUM_REPORT_LOCALE)
        : ROUTE_CONSTANT.AUTISM_SPECTRUM_REPORT;
      break;
    case APP_NAVIGATION.HIGHLY_SENSITIVE_PERSON_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.HIGHLY_SENSITIVE_PERSON_REPORT_LOCALE)
        : ROUTE_CONSTANT.HIGHLY_SENSITIVE_PERSON_REPORT;
      break;
    case APP_NAVIGATION.ATTACHMENT_STYLE_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.ATTACHMENT_STYLE_REPORT_LOCALE)
        : ROUTE_CONSTANT.ATTACHMENT_STYLE_REPORT;
      break;
    case APP_NAVIGATION.DYSLEXIA_SCREENING_CHILDREN_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DYSLEXIA_SCREENING_CHILDREN_REPORT_LOCALE)
        : ROUTE_CONSTANT.DYSLEXIA_SCREENING_CHILDREN_REPORT;
      break;
    case APP_NAVIGATION.DYSLEXIA_SCREENING_ADULT_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DYSLEXIA_SCREENING_ADULT_REPORT_LOCALE)
        : ROUTE_CONSTANT.DYSLEXIA_SCREENING_ADULT_REPORT;
      break;
    case APP_NAVIGATION.LOVE_STYLE_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.LOVE_STYLE_REPORT_LOCALE)
        : ROUTE_CONSTANT.LOVE_STYLE_REPORT;
      break;
    case APP_NAVIGATION.NARCISSISTIC_PERSONALITY_DISORDER_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(
            ROUTE_CONSTANT.NARCISSISTIC_PERSONALITY_DISORDER_REPORT_LOCALE
          )
        : ROUTE_CONSTANT.NARCISSISTIC_PERSONALITY_DISORDER_REPORT;
      break;
    case APP_NAVIGATION.ANTISOCIAL_PERSONALITY_DISORDER_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(
            ROUTE_CONSTANT.ANTISOCIAL_PERSONALITY_DISORDER_REPORT_LOCALE
          )
        : ROUTE_CONSTANT.ANTISOCIAL_PERSONALITY_DISORDER_REPORT;
      break;
    case APP_NAVIGATION.FOUR_TEMPERAMENT_PERSONALITY_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(
            ROUTE_CONSTANT.FOUR_TEMPERAMENT_PERSONALITY_REPORT_LOCALE
          )
        : ROUTE_CONSTANT.FOUR_TEMPERAMENT_PERSONALITY_REPORT;
      break;
    case APP_NAVIGATION.DASHBOARD:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DASHBOARD_LOCALE)
        : ROUTE_CONSTANT.DASHBOARD;
      break;
    case APP_NAVIGATION.SETTINGS:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.SETTINGS_LOCALE)
        : ROUTE_CONSTANT.SETTINGS;
      break;
    case APP_NAVIGATION.CHECKOUT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CHECKOUT_LOCALE)
        : ROUTE_CONSTANT.CHECKOUT;
      break;
    case APP_NAVIGATION.PLAN:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.PAYMENT_PLAN_LOCALE)
        : ROUTE_CONSTANT.PAYMENT_PLAN;
      break;
    case APP_NAVIGATION.CONFIRMATION:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CONFIRMATION_LOCALE)
        : ROUTE_CONSTANT.CONFIRMATION;
      break;
    case APP_NAVIGATION.CHECKOUT_B:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CHECKOUT_B_LOCALE)
        : ROUTE_CONSTANT.CHECKOUT_B;
      break;
    case APP_NAVIGATION.CHECKOUT_C:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.CHECKOUT_C_LOCALE)
        : ROUTE_CONSTANT.CHECKOUT_C;
      break;
    case APP_NAVIGATION.QUIZ:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.QUIZ_LOCALE)
        : ROUTE_CONSTANT.QUIZ;
      break;
    case APP_NAVIGATION.QUIZ_B:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.QUIZ_B_LOCALE)
        : ROUTE_CONSTANT.QUIZ_B;
      break;
    case APP_NAVIGATION.ROMANTIC_PERSONAL_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.ROMANTIC_PERSONALITY_REPORT_LOCALE)
        : ROUTE_CONSTANT.ROMANTIC_PERSONALITY_REPORT;
      break;
    case APP_NAVIGATION.ROMANTIC_COMPATIBILITY_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.ROMANTIC_COMPATIBILITY_REPORT_LOCALE)
        : ROUTE_CONSTANT.ROMANTIC_COMPATIBILITY_REPORT;
      break;
    case APP_NAVIGATION.COLOR_BLIND_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.COLOR_BLIND_REPORT_LOCALE)
        : ROUTE_CONSTANT.COLOR_BLIND_REPORT;
      break;
    case APP_NAVIGATION.DEPRESSION_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.DEPRESSION_REPORT_LOCALE)
        : ROUTE_CONSTANT.DEPRESSION_REPORT;
      break;
    case APP_NAVIGATION.BIPOLAR_DISORDER_REPORT:
      pathValue.next = !!locale
        ? setLocaleURL(ROUTE_CONSTANT.BIPOLAR_DISORDER_REPORT_LOCALE)
        : ROUTE_CONSTANT.BIPOLAR_DISORDER_REPORT;
      break;
  }
  return pathValue;
};

export default PathHelper;
